import { Box } from "@amzn/awsui-components-console";

import { useChatHistory } from "@/contexts/ChatHistoryContext";

import useModal from "../useModal";

export interface UseDeleteModalProps {
  chatId: string;
  title: string;
}

const useDeleteModal = ({ chatId, title }: UseDeleteModalProps) => {
  const { loading, deleteChatById } = useChatHistory();

  const handleDelete = async () => deleteChatById(chatId);

  return useModal({
    title: "Delete Chat",
    onConfirm: handleDelete,
    content: (
      <Box>
        This will delete the chat <strong>{title}</strong>. Are you sure you
        want to proceed?
      </Box>
    ),
    loading,
  });
};

export default useDeleteModal;
